import { NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  BounceBarsLoaderComponent,
} from '@modules/loaders/components/loader-types/bounce-bars-loader/bounce-bars-loader.component';
import {
  BounceDotsLoaderComponent,
} from '@modules/loaders/components/loader-types/bounce-dots-loader/bounce-dots-loader.component';
import {
  GrowingBarsLoaderComponent,
} from '@modules/loaders/components/loader-types/growing-bars-loader/growing-bars-loader.component';
import {
  InfinityLoaderComponent,
} from '@modules/loaders/components/loader-types/infinity-loader/infinity-loader.component';
import {
  MusicBarsLoaderComponent,
} from '@modules/loaders/components/loader-types/music-bars-loader/music-bars-loader.component';
import {
  RotatingSquareLoaderComponent,
} from '@modules/loaders/components/loader-types/rotating-square-loader/rotating-square-loader.component';
import {
  SpinnerLoaderComponent,
} from '@modules/loaders/components/loader-types/spinner-loader/spinner-loader.component';
import { TimeLoaderComponent } from '@modules/loaders/components/loader-types/time-loader/time-loader.component';

import { LoaderHelper } from '@modules/loaders/helpers/loader-helper';

import { WebsiteLoader } from '@modules/loaders/interfaces/website-loader.interface';
import { LoaderService } from '@modules/loaders/services/loader.service';

@Component({
  selector: 'app-loaders-wrapper-small',
  templateUrl: './loaders-wrapper-small.component.html',
  styleUrls: ['./loaders-wrapper-small.component.scss'],
  standalone: true,
  imports: [
    NgSwitch,
    NgSwitchCase,
    SpinnerLoaderComponent,
    InfinityLoaderComponent,
    TimeLoaderComponent,
    BounceDotsLoaderComponent,
    RotatingSquareLoaderComponent,
    GrowingBarsLoaderComponent,
    BounceBarsLoaderComponent,
    MusicBarsLoaderComponent,
  ],
})
export class LoadersWrapperSmallComponent extends LoaderHelper {
  @Input() className = 'loader';

  constructor(
    loaderService: LoaderService,
  ) {
    super();
    loaderService.composedLoaderSettings.subscribe((result: WebsiteLoader) => {
      if (!result) {
        return;
      }
      this.loader = result;
    });
  }
}
